import { mapState, mapMutations } from 'vuex';
import ApiService from '../services/apiService';
import { themesMixin } from '../utils/themes';
import debounce from 'lodash/debounce';
export default {
  name: 'ViewChangePassword',
  mixins: [themesMixin],
  data: function () {
    return {
      valid: false,
      password1: '',
      password2: '',
      marker: false,
      tenantName: null,
      passwordError: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'CustomTheme']),
    token() {
      return this.$route.query.token;
    },
    passwordIsValid() {
      return this.password1 === this.password2;
    },
    passwordHasError() {
      return this.passwordError && typeof this.passwordError === 'string';
    },
    loginLogo() {
      return this.themeGetLogoObject();
    },
    loginBackground() {
      return this.themeGetBackground();
    },
    password2Rules() {
      return [v => !!v && v === this.password1 || this.$i18n_t('accMgmt.user.pwdMissmatch')];
    },
    passwordRules() {
      return [v => !!v || this.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED'), v => !!v && typeof this.validatePassword() === 'string' || true];
    }
  },
  mounted() {
    document.getElementsByTagName('html')[0].classList.add('hide__scrollbar');
  },
  beforeDestroy() {
    document.getElementsByTagName('html')[0].classList.remove('hide__scrollbar');
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    handleSubmit() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.submitted = true;
      this.validate();
      if (!this.passwordIsValid) {
        this.$snack(this.$i18n_t('accMgmt.user.pwdMissmatch'), 'error');
        return;
      }
      return ApiService.resetPasswordWithToken(this.token, this.password1).then(() => {
        this.$snack(this.$i18n_t('accMgmt.user.pwdChgSuccess'), 'success');
        this.$store.dispatch('authentication/logout').then(() => {
          this.$router.push('/login');
        }).catch(error => {
          throw error;
        });
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.user.pwdChgFail'), 'error');
        }
      });
    },
    validate() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.snackbar = true;
      }
    },
    validatePassword: debounce(function () {
      return ApiService.validateUserPassword(this.password1, undefined, this.token).then(result => {
        if (typeof result === 'string') {
          const matches = result.match(/(.+?)_([0-9]+)$/);
          // special handling: length is encoded in error-message
          if (matches && matches.length) {
            let length = parseInt(matches[2]);
            let message = matches[1];
            this.passwordError = this.$i18n_tc(`accMgmt.user.passwordErrors.${message}`, length, {
              n: length
            });
          } else {
            this.passwordError = this.$i18n_t(`accMgmt.user.passwordErrors.${result}`);
          }
        } else {
          this.passwordError = null;
        }
      });
    }, 250)
  }
};